import React from 'react';
import { Col } from 'react-bootstrap';

const TickerNewsItem = ({ newsItem }) => {
  const { title, description, link, pubDate } = newsItem;
  return (
    <Col md={12} className="ticker-news-item">
      <div>
        <h4 className="title">
          <a href={link[0]} target="_blank" dangerouslySetInnerHTML={{ __html: title[0] }} />
        </h4>
        <p dangerouslySetInnerHTML={{ __html: description[0] }}></p>
        <span className="date">{new Date(pubDate[0]).toLocaleString()}</span>
        <hr />
      </div>
    </Col>
  );
}

export default TickerNewsItem;